
    export const BRANDING_COLOR = "#E20074"
    export const SIGNATURE_THRESHOLD_AMOUNT = undefined
    export const USE_RICH_CHECKOUT = "true"
    export const RICH_CHECKOUT_DEEPLINK_SCHEMA = "https://tmobile.ordernext.com/"
    export const RICH_CHECKOUT_TEXT_PROMPT = "Scan this code with our official team app"
    export const PUSHER_KEY = "1a713dd51f69a0de4b4b"
    export const PUSHER_CLUSTER = "us2"
    export const TEAM_LOGO_EXISTS = false
    export const PRINTING_ENABLED = true
    export const CLOUDINARY_NAME = 'venuenext'
    export const CLOUDINARY_PRESET_NAME = 'venuenext'
    export const NOTES_CHARACTER_LIMIT = 255
    export const PIN_CODE_CONFIGURATION_ACCESS = '100710'
    export const DAYS_TO_FORCE_MAINTENANCE = 7
  